// extracted by mini-css-extract-plugin
export default {"layout":"layout_layout__UJ5Fn","container":"layout_container__Iz5wn","content":"layout_content__Cc91t"};